<template>
  <div v-if="user || currentCourse && currentCourse.isPublic">
   
    <div class="course-lessons">
      <div v-if="sortedEvents.length">

        <LessonPreview2
                  v-for="(e, idx) in sortedEvents"
                  :key="idx"
                  :lesson="e"
                  @selectVideo="selectVideo"
                  @beginWebinar="beginWebinar"
                  @startWebinar="startWebinar"
                />
      </div>
      <p v-else>{{ t("teacher.didnt.add.lessons") }}</p>

      <NVideoModal
        v-if="showVideo"
        :video="video"
        @closeModal="closeVideoModal"
      />

      <WebinarModal
        v-if="showWebinar"
        @closeModal="showWebinar = false"
        :webinar="webinar"
      />
    </div>
  </div>
  <LoginPlease v-else />
</template>

<script>
import { computed, ref } from "vue";

import { t } from "@/utils/translate";
import { useUserStore } from "@/store/userStore";
import { usePopupStore } from "@/store/popupStore";

import { storeToRefs } from "pinia";
import { customAxios } from "@/service/customAxios";

import NVideoModal from "@/components/NVideoModalNative.vue";

import LessonPreview2 from "@/components/LessonPreview2.vue";

import LoginPlease from "@/elements/LoginPlease.vue";
import WebinarModal from "@/components/WebinarModal.vue";

const webinarRedirect = "Открываем вебинарную комнату в новой вкладке";

export default {
  emits: [
    "joinToCourse",
    "leaveCourse",
    "addToFavorites",
    "removeFromFavorites",
  ],
  components: {
    LessonPreview2,
    NVideoModal,
    LoginPlease,
    WebinarModal,
  },
  created() {},
  setup() {
    const userStore = useUserStore();
    const { currentCourse, isJoined, user } = storeToRefs(userStore);

    const popupStore = usePopupStore();
    const { showPopup } = popupStore;

    const showVideo = ref(false);
    const showWebinar = ref(false);

    const alertDialogMessage = ref("");

    const webinar = ref(null);
    const video = ref(null);

    const sortedEvents = computed(() => {
      const tempEvents = currentCourse.value.eventSet;
      return tempEvents.sort(dynamicSort("eventDateTime", 1));
    });

    function closeVideoModal() {
      showVideo.value = false;
      video.value = null;
    }

    function selectVideo(v) {
      video.value = v;
      showVideo.value = true;
    }

    function startWebinar(v) {
      webinar.value = v;
      showWebinar.value = true;
    }

    function delay(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    }

    function dynamicSort(property, sortOrder) {
      return function (a, b) {
        const result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    }

    async function beginWebinar(item) {
      console.log("Item ID: " + item.id);
      let courseWebinar = {
        webinarId: item.id,
        courseId: currentCourse.value.id,
      };

      try {
        const response = await customAxios.post("webinar/begin", courseWebinar);

        if (response.status === 200) {
          console.log("Seminar Join URL :" + response.data.url);

          if (response.data.url !== null) {
            // webinarRedirectwebinarRedirectDialog.value = true;
            showPopup(webinarRedirect, "warning");
            delay(3000).then(() => {
              window.open(response.data.url, "_blank");
              // webinarRedirectDialog.value = false;
            });
          } else {
            alertDialogMessage.value = response.data.statusComment;
            showPopup(alertDialogMessage.value, "error");
          }
        } else if (response.status === 207) {
          alertDialogMessage.value = response.data.message;
          showPopup(alertDialogMessage.value, "error");
        } else {
          console.log(response);
        }
      } catch (e) {
        console.log(e);
      }
    }

    return {
      user,
      t,
      currentCourse,
      selectVideo,
      sortedEvents,
      showVideo,
      video,
      closeVideoModal,
      startWebinar,
      webinar,
      beginWebinar,
      showWebinar,
      isJoined,
    };
  },
};
</script>

<style lang="scss">
 // =========================================================================
 // 1. АДАПТИВНОСТЬ ДЛЯ СМАРТФОНОВ (Экран меньше 767px)
 // =========================================================================
 @media (max-width: 767px) {
   // Исправляет "хуевращение" меню на телефонах: возвращает стандартный поток
   .course-lessons,
   .lesson-preview,
   .lesson-preview__content {
     display: block !important;
     width: 100% !important;
     max-width: 100% !important;
     box-sizing: border-box;
   }

   // Фикс для мобильного выпадающего меню Vuetify
   :deep(.v-tabs),
   :deep(.v-slide-group),
   :deep(.v-slide-group__content) {
     display: flex !important;
     flex-direction: column !important;
     width: 100% !important;
     min-width: 200px !important;
     box-sizing: border-box;
     background-color: #ffffff !important;
   }

   :deep(.v-tab) {
     width: 100% !important;
     max-width: 100% !important;
     justify-content: flex-start !important;
     padding: 12px 16px !important;
     box-sizing: border-box;
   }

   // Выжигаем накладывающиеся фоновые буквы шапки на смартфонах
   .modal_video_title,
   [class*="modal_video_title"],
   .wave-section_page-title,
   [class*="wave-section_page-title"] {
     display: none !important;
   }
 }

 // =========================================================================
 // 2. ИСПРАВЛЕНО: ДЛЯ ПЛАНШЕТОВ И СРЕДНИХ ЭКРАНОВ (768px - 1199px, включая Nest Hub)
 // Блоки встают друг под друга, убирая пустоту справа и спасая наложение табов
 // =========================================================================
 @media (min-width: 768px) and (max-width: 1199px) {
   .course-lessons {
     display: block !important;
     width: 100% !important;
     padding: 0 16px !important;
   }

   .lesson-preview {
     display: flex !important;
     flex-direction: column !important;
     width: 100% !important;

     &__title {
       text-align: left !important;
       font-size: 20px !important;
       margin-bottom: 16px !important;
     }

     &__content {
       display: flex !important;
       flex-direction: column !important; // Вертикальный стек: видео сверху, текст снизу
       align-items: center !important;
       width: 100% !important;
       gap: 20px !important;
     }

     &__video-block {
       width: 100% !important;
       max-width: 100% !important;
     }
   }

   // Вкладки ("Обзор", "Видео") больше не летают поверх заголовка, а стоят под ним
   .n-tabs,
   [class*="tabs-container"],
   :deep(.v-tabs) {
     display: flex !important;
     justify-content: flex-start !important;
     width: 100% !important;
     margin: 0 0 20px 0 !important;
     position: relative !important;
     top: auto !important;
     left: auto !important;
   }
 }

 // =========================================================================
 // 3. ИДЕАЛЬНОЕ ЦЕНТРИРОВАНИЕ ДЛЯ БОЛЬШИХ ПК-МОНИТОРОВ (Экран от 1200px)
 // =========================================================================
 @media (min-width: 1200px) {
   .course-lessons {
     display: flex !important;
     flex-direction: column !important;
     align-items: center !important; // Центрирует контент по горизонтали страницы
     width: 100% !important;
     max-width: 100% !important;
     margin: 0 auto !important;
   }

   .lesson-preview {
     width: 100% !important;
     max-width: 850px !important; // Зажимаем плеер, чтобы не раздувался
     margin: 0 auto 32px auto !important; // Магия auto центрирует карточку
     display: flex !important;
     flex-direction: column !important;
     box-sizing: border-box;

     &__title {
       text-align: center !important;
       width: 100% !important;
       margin-bottom: 24px !important;
     }

     &__content {
       width: 100% !important;
       max-width: 850px !important;
       margin: 0 auto !important;
       display: flex !important;
       flex-direction: column !important;
       align-items: center !important;
       gap: 20px !important;
     }

     &__video-block {
       width: 100% !important;
       max-width: 850px !important;
       margin: 0 auto !important;
     }
   }

   .n-tabs,
   [class*="tabs-container"] {
     display: flex !important;
     justify-content: center !important; // Центрируем строку вкладок над плеером
     width: 100% !important;
     max-width: 850px !important;
     margin: 0 auto 24px auto !important;
   }
 }

 // =========================================================================
 // 4. БАЗОВЫЕ И ОРИГИНАЛЬНЫЕ СТИЛИ ВАШЕГО КОМПОНЕНТА С МИКСИНАМИ
 // =========================================================================
 .course-lessons {
   @include page; // Сохраняем вашу оригинальную структуру страницы

   &__access-denied {
     @include access-denied;
   }

   &__close_button {
     @include flex-center;
     margin: 10px;
     width: 100%;

     span {
       white-space: nowrap;
     }

     &:first-of-type {
       margin-top: 10px;
     }

     &--close {
       @include button-default;
       background-color: $accent-2;

       &:hover {
         background-color: rgba($accent-2, 0.7);
       }
     }
   }

   &__play_button {
     @include flex-center;
     margin: 10px;
     width: 160px;

     span {
       white-space: nowrap;
     }

     &:first-of-type {
       margin-top: 10px;
     }

     &--open {
       @include button-default;
       background-color: $accent-2;

       &:hover {
         background-color: rgba($accent-2, 0.7);
       }
     }
   }
 }
 </style>

